<template>
<v-card v-if="!loading && projects">
          <v-card-title dark>
            <h4>Review Projects</h4>
            <v-spacer></v-spacer>
            <v-btn
              fab
              small
              depressed
              class="white--text"
              color="green"
              title="Add"
             :to="'/projects/create'"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
           <v-divider></v-divider>
           <div>
    <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Project Title
          </th>          
          <th class="text-left">
            Date
          </th>
          <th class="text-left">
            Type
          </th>
          <th class="text-left">
            Status 
          </th>
          <th class="text-left">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in projects"
          :key="item.name"
        >
          <td>{{item.name}}</td>
          <td>{{item.date}}</td>
          <td>{{item.type}}</td>
          <td><v-chip small class="ma-2" dark :color="getStatusColor(item.status)">
                 {{item.status}}
                </v-chip></td>
          <td><v-btn small  dark color="blue">View</v-btn></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  </div>
          
        </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "ProjectGrid",
  components: {
    
  },
  data: function() {
    return {
        projects: [
      {
        name: "Vission Project",
        date: "2022-06-12",
        type: "SP",
        status: "SUBMITTED",
      },
      {
        name: "Health Project",
        date: "2022-06-10",
        type: "CP",
        status: "SUBMITTED",
      }
      ],
      step: 1,     
    };
  },
  computed: {
    ...mapGetters({     
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");  
    console.log(localStorage.getItem('role'));
  },

  watch: {
   
  },

  methods: {
      editOpen(){
        
      },
      getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "SUBMITTED":
          bgColor = "blue";
          break;

        case status === "PENDING":
          bgColor = "red";
          break;

        case status === "APPROVED":
          bgColor = "green";
          break;
        default:
          bgColor = "orange";
          break;
      }
      return bgColor;
    },
    },   
  
};
</script>
